<template>
  <div class="home">
    <div class="row mb-20">
      <div class="w-70">
        <NewsCarousel class="mb-20" />
        <TrendsCard class="mb-20" :list="noticeList" />
        <div class="row mb-20">
          <HomeCard
            class="flex-1"
            title="行业资讯"
            type="information"
            :list="informationList"
          />
          <HomeCard
            class="flex-1 ml-20"
            title="百年吉菜"
            type="elegantDemeanour"
            :list="elegantDemeanourList"
          />
        </div>
        <div class="row mb-20">
          <HomeCard
            class="flex-1"
            title="技能认证"
            type="trainingEducation"
            :list="trainingEducationList"
          />
          <HomeCard
            class="flex-1 ml-20"
            title="饮食文化"
            type="dietaryCulture"
            :list="dietaryCultureList"
          />
        </div>
      </div>
      <div class="flex-1 ml-15">
        <NoticeCard class="mb-20" :list="trendsList" />
        <RuleCard class="mb-20" :list="ruleList" />
        <ImageCard
          height="83px"
          v-for="item in activityList"
          :key="item.id"
          :src="`${baseUrl}/${item.imgUrl}`"
          :linkUrl="item.linkUrl"
        />
      </div>
    </div>
    <div class="row mb-20">
      <ImageCard
        v-for="item in bottom1List"
        :key="item.id"
        :src="`${baseUrl}/${item.imgUrl}`"
        :linkUrl="item.linkUrl"
        class="flex-1"
        height="98px"
      />
      <ImageCard
        v-for="item in bottom2List"
        :key="item.id"
        :src="`${baseUrl}/${item.imgUrl}`"
        :linkUrl="item.linkUrl"
        class="flex-1 ml-20"
        height="98px"
      />
    </div>
    <div class="row mb-20">
      <ImageCard
        v-for="item in bottom3List"
        :key="item.id"
        :src="`${baseUrl}/${item.imgUrl}`"
        :linkUrl="item.linkUrl"
        class="flex-1"
        height="58px"
      />
    </div>
    <div class="row mb-20">
      <FriendlyLinks />
    </div>

    <!-- 飘浮框   -->
    <BaywindowContent
      v-for="item in advertisementList"
      :key="item.id"
      :item="item"
      :height="100"
      :width="250"
    />
  </div>
</template>

<script>
import NoticeCard from './components/NoticeCard';
import TrendsCard from './components/TrendsCard';
import RuleCard from './components/RuleCard';
import HomeCard from './components/HomeCard';
import ImageCard from './components/ImageCard';
import NewsCarousel from './components/NewsCarousel';
import BaywindowContent from './components/BaywindowContent';
import FriendlyLinks from './components/FriendlyLinks';
import { getList, getLogo } from '@/api';

export default {
  name: 'homeContent',
  components: {
    NewsCarousel,
    NoticeCard,
    TrendsCard,
    RuleCard,
    HomeCard,
    ImageCard,
    BaywindowContent,
    FriendlyLinks,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
      noticeList: [],
      trendsList: [],
      ruleList: [],
      informationList: [],
      elegantDemeanourList: [],
      trainingEducationList: [],
      dietaryCultureList: [],
      activityList: [],
      bottom1List: [],
      bottom2List: [],
      bottom3List: [],
      advertisementList: [],
    };
  },
  mounted() {
    this.getNoticeList();
    this.getTrendsList();
    this.getRuleList();
    this.getInformationList();
    this.getElegantDemeanourList();
    this.getTrainingEducationList();
    this.getDietaryCultureList();
    this.getActivityList();
    this.getBottom1List();
    this.getBottom2List();
    this.getBottom3List();
    this.getAdvertisementList();
  },
  methods: {
    // 公告通知
    async getNoticeList() {
      const { code, result } = await getList({
        columnCode: 'notice',
        pageSize: 17,
      });
      this.noticeList = result.records;
    },
    // 协会动态
    async getTrendsList() {
      const { code, result } = await getList({
        columnCode: 'trends',
        pageSize: 7,
      });
      this.trendsList = result.records;
    },
    // 政策法规
    async getRuleList() {
      const { code, result } = await getList({
        columnCode: 'rule',
        pageSize: 6,
      });
      this.ruleList = result.records;
    },
    // 行业资讯
    async getInformationList() {
      const { code, result } = await getList({
        columnCode: 'information',
        pageSize: 4,
      });
      this.informationList = result.records;
    },
    // 会员风采
    async getElegantDemeanourList() {
      const { code, result } = await getList({
        columnCode: 'elegantDemeanour',
        pageSize: 4,
      });
      this.elegantDemeanourList = result.records;
    },
    // 培训教育
    async getTrainingEducationList() {
      const { code, result } = await getList({
        columnCode: 'trainingEducation',
        pageSize: 4,
      });
      this.trainingEducationList = result.records;
    },
    // 饮食文化
    async getDietaryCultureList() {
      const { code, result } = await getList({
        columnCode: 'dietaryCulture',
        pageSize: 4,
      });
      this.dietaryCultureList = result.records;
    },
    // 飘窗广告
    async getAdvertisementList() {
      const { code, result } = await getLogo({ type: 'advertisement' });
      this.advertisementList = result;
    },
    // 专题活动
    async getActivityList() {
      const { code, result } = await getLogo({ type: 'activity' });
      this.activityList = result;
    },
    // 底部活动
    async getBottom1List() {
      const { code, result } = await getLogo({ type: 'bottom1' });
      this.bottom1List = result;
    },
    // 专题活动
    async getBottom2List() {
      const { code, result } = await getLogo({ type: 'bottom2' });
      this.bottom2List = result;
    },
    // 专题活动
    async getBottom3List() {
      const { code, result } = await getLogo({ type: 'bottom3' });
      this.bottom3List = result;
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: center;
  .w-70 {
    width: 70%;
  }
  .w-30 {
    width: 30%;
  }
  .w-50 {
    width: 50%;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .ml-15 {
    margin-left: 15px;
  }
  .ml-20 {
    margin-left: 20px;
  }
  .ml-40 {
    margin-left: 40px;
  }
  .flex-1 {
    flex: 1;
    width: 0;
  }
}
</style>
